import React from "react";
interface SuccessProps {
  text: string;
  className?: string;
}

const Success = ({ text, className }: SuccessProps) => {
  function CheckIcon(
    props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
  ) {
    return (
      <svg
        {...props}
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <polyline points="20 6 9 17 4 12" />
      </svg>
    );
  }

  return (
    <span className="self-start inline-flex flex-row  items-center rounded bg-green-500/10  px-2 py-1 text-sm font-medium dark:text-green-400 text-green-500 ring-1 ring-inset dark:ring-green-500/20 ring-green-500/40">
      <CheckIcon className="h-4 w-4 mr-1" /> {text}
    </span>
  );
};

export default Success;
